export const DEFAULT_YEAR = 2026;
export const YEARS = [2026, 2025, 2024, 2023, 2022, 2021];

export const DEFAULT_DIVISION = 'ncaa_3';
export const DIVISIONS = ['ncaa_1', 'ncaa_2', 'ncaa_3'];
export const DIVISION_LABELS = {
  ncaa_1: 'D1',
  ncaa_2: 'D2',
  ncaa_3: 'D3',
};

const _TO_API = { 1: 'ncaa_1', 2: 'ncaa_2', 3: 'ncaa_3' };
/** Convert any division value (int or string) to the API string format. */
export const toDivisionApi = (d) => (DIVISIONS.includes(d) ? d : _TO_API[d] ?? DEFAULT_DIVISION);

const _TO_INT = { ncaa_1: 1, ncaa_2: 2, ncaa_3: 3, '1': 1, '2': 2, '3': 3 };
/** Convert any division value (string or int) to the Firestore integer format. */
export const toDivisionInt = (d) => (typeof d === 'number' && d >= 1 && d <= 3 ? d : _TO_INT[d] ?? 3);

export const TEAM_FALLBACK = "https://d3-dashboard-kellyjc.s3.us-east-2.amazonaws.com/images/0.png";
export const PLAYER_HEADSHOT_FALLBACK = "https://d3-dashboard-kellyjc.s3.us-east-2.amazonaws.com/images/default-silhouette.png";